import styled from 'styled-components';
import { List } from 'antd';

export const PrioritiesWrapper = styled(List.Item)`
    .ant-list-item-content {
        flex-direction: column;
    }
`;
